module.exports = __webpack_public_path__ + "media/images/games/35reveal/fireplace-8f8fce7d52c182f0336ac316455e1585.png";